import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import styled from 'styled-components';
import {transitions} from 'polished';

// Components
import {Icon} from '@drivesally/sally-ui';

// Lib
import {lib} from '@drivesally/sally-ui';

// Colors
const {
  colors: {darkGrey, black, red, orange},
} = lib;

// Helper components
const Container = styled.div`
  height: 100%;
  position: relative;
  margin-right: 50px;
`;

const Content = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  color: ${({selected}) => (selected ? black : darkGrey)};
  font-weight: 700;
  font-size: 12px;
  white-space: nowrap;
  text-transform: uppercase;
  ${transitions('color .3s ease-in-out')};

  &:hover {
    color: ${black};
  }
`;

const StyledIcon = styled(Icon)`
  font-size: 20px !important;
  margin-right: 10px;
  vertical-align: middle;
  transform: translateY(-1px);
`;

const Line = styled.div`
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
  height: 2px;
  background: ${red};
`;

const Badge = styled.div`
  background: ${orange};
  color: ${black};
  margin-left: 10px;
  font-size: 10px;
  padding: 3px 4px;
  font-weigth: 500;
  border-radius: 4px;
`;

const NavigationButton = ({
  icon,
  url,
  children,
  selected,
  badge,
  onClick,
  external,
}) => (
  <Container>
    {external ? (
      <a href={url} target="_blank" rel="noopener noreferrer">
        <Content selected={selected} onClick={onClick}>
          {!!icon && <StyledIcon icon={icon} />}
          {children}
          {!!badge && <Badge>{badge > 99 ? '99+' : badge}</Badge>}
        </Content>
      </a>
    ) : (
      <Link to={url}>
        <Content selected={selected} onClick={onClick}>
          {!!icon && <StyledIcon icon={icon} />}
          {children}
          {!!badge && <Badge>{badge > 99 ? '99+' : badge}</Badge>}
        </Content>
      </Link>
    )}
    {selected && <Line />}
  </Container>
);

NavigationButton.propTypes = {
  icon: PropTypes.string,
  url: PropTypes.string,
  children: PropTypes.node,
  selected: PropTypes.bool,
  badge: PropTypes.number,
  onClick: PropTypes.func,
  external: PropTypes.bool,
};

NavigationButton.defaultProps = {
  selected: false,
  badge: 0,
};

export default NavigationButton;
